import React from 'react'
import { Typography } from 'atoms/Typography'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import translate from 'core/translate'
import styles from './deviceSettings__changeIpTvVolumeFromRemote.jcss'
import { Radio } from 'atoms/Radio'

export const ChangeIpTvVolumeFromRemote = (p_: {
    changeIpTvVolumeFromRemote: boolean
    onChange: (value: boolean) => void
    enabled: boolean
    ipTvEnabled: boolean
}) => {
    return p_.enabled && p_.ipTvEnabled ? (
        <React.Fragment>
            <Typography className={cn(grid.mb_md, styles.title)} type="title">
                {translate('changeIpTvVolumeFromRemote')}
            </Typography>
            <div className={styles.radioButtons}>
                <Radio
                    label={translate('allow')}
                    selected={p_.changeIpTvVolumeFromRemote}
                    className={grid.mr_md}
                    onClick={() => p_.onChange(true)}
                />
                <Radio
                    label={translate('disallow')}
                    selected={!p_.changeIpTvVolumeFromRemote}
                    onClick={() => p_.onChange(false)}
                />
            </div>
        </React.Fragment>
    ) : null
}
